import * as React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function Calendar({ color, size, ...props }) {
  return (
    <Svg
      fill="none"
      height={size}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      viewBox="0 0 24 24"
      width={size}
      {...props}
    >
      <Path d="M8 2v4M16 2v4M3 10h18" />
      <Rect height={18} rx={2} width={18} x={3} y={4} />
    </Svg>
  );
});
